import { ExecutionBriefTemplateLabels } from "../../../../../types/templates/execution-brief/execution-brief-template-labels.constant";

import { matchByValue } from "../../../../filters/inputs/autocomplete/autocomplete.functions";

import { IForm } from "../../../form-modal/form-modal.types";
import { TextInput } from "../../../form-modal/inputs/text-input/text-input.component";
import { Autocomplete } from "../../../form-modal/inputs/autocomplete/autocomplete.component";

export const NewExecutionBriefForm = (props: IForm) => {
  return (
    <>
      <TextInput form={props.form} label="Name" name="name" required />
      <Autocomplete
        form={props.form}
        fullWidth
        label="Template"
        name="resourcetype"
        optionSelected={matchByValue}
        options={ExecutionBriefTemplateLabels}
        placeholder="Select a template"
        required
      />
    </>
  );
};
